// export const MembershipPlans = {
//     monthly: {
//         title: "Monthly",
//         price: 9.49,
//         currency: "GBP",
//         formattedPrice: "£9.99",
//         country: "GB",
//         productId: "ProMonthly",
//     },
//     yearly: {
//         title: "Yearly",
//         price: 49.99,
//         currency: "GBP",
//         formattedPrice: "£49.00",
//         country: "GB",
//         productId: "ProAnnual",
//     },
//     lifetime: {
//         title: "Lifetime",
//         price: 149.99,
//         currency: "GBP",
//         formattedPrice: "£149",
//         country: "GB",
//         productId: "ProLife",
//     },
// };

export enum MembershipPeriod {
    Monthly = 'monthly',
    Yearly = 'yearly',
    Lifetime = 'lifetime',
    Basic = 'basic',
}

export const basicPlan = {
    Title: 'Basic',
    ProductId: 'Basic',
    Price: 0,
    Currency: '',
    FormattedPrice: '',
    Country: '',
}
export interface MembershipPlan {
    Title: string;
    ProductId: string;
    Price: number;
    Currency: string;
    FormattedPrice: string;
    Country: string;
}

// export const mapApiResponseToPlan = (item: {
//     ProductId: string;
//     Price: number;
//     Currency: string;
//     FormattedPrice: string;
//     Country: string;
// }): Omit<MembershipPlan, 'title'> => ({
//     productId: item.ProductId,
//     price: item.Price,
//     currency: item.Currency,
//     formattedPrice: item.FormattedPrice,
//     country: item.Country
// });

